// @refresh reload
import './app.css';
import { withSentryRouterRouting } from '@sentry/solidstart/solidrouter';
import { MetaProvider } from '@solidjs/meta';
import { Router } from '@solidjs/router';
import { FileRoutes } from '@solidjs/start/router';
import { onMount, Suspense } from 'solid-js';
import { ErrorFallback } from '~/components/common/ErrorFallback';
import { AuthGuard } from '~/global-contexts/Auth';
import { Cobrowse } from './components/common/Cobrowse';
import { ImagePreview } from './components/common/ImagePreview';
import { Intercom } from './components/common/Intercom';
import { Toaster } from './components/common/toaster/Toaster';
import { MenuProvider } from './components/layouts/Menu';
import Navigator from './framework/Navigator';
import useUseCase from './framework/hooks/useUseCase';
import { CompanyStyling } from './global-contexts/CompanyStyling';
import { DeactivatedLeases } from './global-contexts/DeactivatedLeases';
import { ErrorHandler } from './global-contexts/error/ErrorHandler';
import { InitializeAppUseCase } from './use-cases/initializeAppUseCase';
const SentryRouter = withSentryRouterRouting(Router);

export default function Root() {
  const { execute: initializeApp } = useUseCase(InitializeAppUseCase);

  onMount(() => {
    initializeApp();
  });

  return (
    <SentryRouter
      root={(props) => (
        <Suspense>
          <Intercom />
          <Cobrowse />
          <ErrorHandler fallback={(error, reset) => <ErrorFallback error={error} reset={reset} />}>
            <MetaProvider>
              <AuthGuard>
                <CompanyStyling>
                  <Navigator />
                  <MenuProvider>
                    <DeactivatedLeases>{props.children}</DeactivatedLeases>
                  </MenuProvider>
                  <ImagePreview />
                  <Toaster />
                </CompanyStyling>
              </AuthGuard>
            </MetaProvider>
          </ErrorHandler>
        </Suspense>
      )}>
      <FileRoutes />
    </SentryRouter>
  );
}
